import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { invalidatePostQueries } from 'common/actions/postQueries';
import { reloadPost } from 'common/actions/posts';
import AJAX from 'common/AJAX';
import connect from 'common/core/connect';
import Tappable from 'common/Tappable';

import 'css/components/subdomain/admin/_AdminJiraIssues.scss';

class AdminJiraIssues extends Component {
  static propTypes = {
    post: PropTypes.object,
  };

  state = {
    removing: false,
  };

  onRemoveIssue = (issue) => {
    const { removing } = this.state;
    if (removing) {
      return;
    }

    this.setState({
      removing: true,
    });

    const { post, reloadPost } = this.props;
    AJAX.post(
      '/api/jira/unlinkIssue',
      {
        issueID: issue.id,
        postID: post._id,
      },
      (response) => {
        if (response === 'success') {
          reloadPost(post).then(() => {
            this.setState({
              removing: false,
            });
          });
        } else {
          this.setState({
            removing: false,
          });
        }
      },
    );
  };

  renderIssues() {
    const {
      post: { jiraIssues },
    } = this.props;

    const items = [];
    jiraIssues.forEach((issue) => {
      const remove = (
        <Tappable onTap={this.onRemoveIssue.bind(this, issue)}>
          <div className="icon icon-x" />
        </Tappable>
      );
      items.push(
        <div key={issue.id} className="issue">
          <a href={issue.url} rel="noopener" target="_blank">
            {'[' + issue.key + '] ' + issue.summary}
          </a>
          {remove}
        </div>,
      );
    });

    return items;
  }

  render() {
    const {
      post: { jiraIssues },
    } = this.props;
    if (!jiraIssues || !jiraIssues.length) {
      return null;
    }

    return <div className="adminJiraIssues">{this.renderIssues()}</div>;
  }
}

export default connect(null, (dispatch) => ({
  reloadPost: (post) => {
    return Promise.all([dispatch(invalidatePostQueries()), dispatch(reloadPost(post))]);
  },
}))(AdminJiraIssues);
